export const environment = {
    production: false,
    apiurls: {
        baseUrl: 'https://boxing-backend.hardkore.tech/api/'
    }
};

